export default {"src":"/_next/static/media/Twitter.812ba609.svg","height":50,"width":51,"blurWidth":0,"blurHeight":0};